import { Outlet, useLocation } from 'react-router-dom';
import { ClipboardList, Store, Users } from 'lucide-react';

export function MerchantAuthLayout() {
  const location = useLocation();
  return (
    <div
      className="mer-auth"
      data-auth-surface="merchant"
      data-auth-page={location.pathname === '/merchant-sign-in' ? 'sign-in' : undefined}
    >
      <aside className="mer-auth-story">
        <div className="mer-auth-brand">
          BeatQ Eats <span>Merchant</span>
        </div>
        <div className="mer-auth-message">
          <p className="mer-auth-eyebrow">Made for the way you work</p>
          <h2>
            Great service.
            <br />
            Starts here.
          </h2>
          <p>
            From the first order to the final handover. Everything your team needs, in one place.
          </p>
          <div className="mer-auth-features">
            <div>
              <ClipboardList size={21} />
              <span>
                <strong>Keep orders moving</strong>
                <small>From incoming to ready for collection.</small>
              </span>
            </div>
            <div>
              <Store size={21} />
              <span>
                <strong>Make your storefront yours</strong>
                <small>Your menu, availability and opening hours.</small>
              </span>
            </div>
            <div>
              <Users size={21} />
              <span>
                <strong>Bring your team together</strong>
                <small>The right tools for every role.</small>
              </span>
            </div>
          </div>
        </div>
        <p className="mer-auth-footer">Your business. Your team. BeatQ Eats.</p>
      </aside>
      <main id="main" tabIndex={-1} className="mer-auth-main">
        <div className="auth-form-column">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
